// LoginPage.jsx
import React, { useState } from "react";
import {
    Box,
    Paper,
    TextField,
    Button,
    Typography,
    CssBaseline,
    ThemeProvider,
    createTheme,
    useTheme,
    useMediaQuery,
    Alert,
} from "@mui/material";
import { users } from "../Utils/Users";
import { useAuth } from "../Context/AuthContext";

const theme = createTheme({
    palette: {
        primary: {
            main: "#0A3A67", // deep blue
        },
        background: {
            default: "#F7F9FC",
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
});

export default function LoginPage({ ToHome }) {
    const muiTheme = useTheme() || theme;
    const isSmall = useMediaQuery(muiTheme.breakpoints.down("md"));
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loginError, setLoginError] = useState("");
    const { createSessionForUser } = useAuth();


    const handleLogin = () => {
        const validUser = users.find(
            (user) => user.username === username && user.password === password
        );
        if (validUser) {
            createSessionForUser(username);
            ToHome();
        } else {
            console.log("Invalid username or password");
            setLoginError("Invalid username or password");
        }
    }

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />

            {/* Full-page wrapper with diagonal background */}
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "stretch",
                    justifyContent: "center",
                    backgroundImage:
                        "linear-gradient(180deg, #0A3A67 0%, #0A3A67 50%, #F7F9FC 50%, #F7F9FC 100%)",
                }}
            >
                {/* Inner content container */}
                <Box
                    sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center"
                    }}
                >
                    {/* LEFT: Branding / Quotes */}
                    <Box
                        sx={{

                            color: "white",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            px: { xs: 4, md: 8 },
                            py: { xs: 4, md: 0 },
                            // allow scroll on smaller screens so quotes don't get cut
                            overflowY: "auto",
                        }}
                    >

                        <Box
                            component="img"
                            src="Principal_Logo_1.png" // <-- replace with your logo path
                            alt="logo"
                            sx={{ width: 200 }}
                        />

                        <Typography
                            variant={isSmall ? "h6" : "h5"}
                            sx={{ mt: 2, mb: 3, maxWidth: 520 }}
                        >
                            RFP Triaging and Quoting Engine
                        </Typography>


                    </Box>

                    {/* RIGHT: Login card */}
                    <Box
                        sx={{

                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            p: { xs: 4, md: 6 },
                        }}
                    >
                        <Paper
                            elevation={6}
                            sx={{
                                width: "100%",
                                maxWidth: 380,
                                p: 6,
                                borderRadius: 2,
                                textAlign: "center",
                                bgcolor: "rgba(255,255,255,0.98)",
                                mt: 2,

                            }}
                        >
                            <Typography
                                variant="h5"
                                sx={{ mb: 2, fontWeight: 700, color: "primary.main" }}
                            >

                            </Typography>

                            {/* <Typography variant="body2" sx={{ mb: 3, color: "text.secondary" }}>
                                Login to access RFP dashboard
                            </Typography> */}

                            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                <TextField label="Username" fullWidth size="small" value={username} onChange={(e) => setUsername(e.target.value)} />
                                <TextField
                                    label="Password"
                                    type="password"
                                    fullWidth
                                    size="small"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            handleLogin();
                                        }
                                    }}
                                />
                                <Button
                                    variant="contained"
                                    fullWidth
                                    sx={{ mt: 1, textTransform: "none", fontWeight: 600 }}
                                    onClick={() => handleLogin()}
                                >
                                    Login
                                </Button>
                                {loginError && <Alert severity="error">{loginError}</Alert>}
                            </Box>
                        </Paper>
                    </Box>
                </Box>
            </Box>
        </ThemeProvider>
    );
}
